import { BehaviorSubject } from 'rxjs';

export default class ResendInviteBloc {
  isResendingInvite$ = new BehaviorSubject(false);
  isInvitingAdmin$ = new BehaviorSubject(false);
  isReInvitingAdmin$ = new BehaviorSubject(false);
  isReInvitingPatient$ = new BehaviorSubject(false);

  constructor({ creatorRepository, drawerRepository, workspaceRepository, adminRepository, patientRepository }) {
    this.creatorRepository = creatorRepository;
    this.drawerRepository = drawerRepository;
    this.workspaceRepository = workspaceRepository;
    this.adminRepository = adminRepository;
    this.patientRepository = patientRepository;
  }

  async resendInvite(name, phoneNumber, email, id) {
    this.isResendingInvite$.next(true);
    try {
      await this.creatorRepository.resendInvite(name, phoneNumber, email, id);
      this.drawerRepository.toggleDrawer(false);
      await this.creatorRepository.getCreators(this.creatorRepository.searchCriteria$.getValue());
    } finally {
      this.isResendingInvite$.next(false);
    }
  }

  async inviteAdmin(name, phoneNumber, email, subdomain) {
    this.isInvitingAdmin$.next(true);
    try {
      await this.adminRepository.inviteAdmin(name, phoneNumber, email, subdomain);
      this.drawerRepository.toggleDrawer(false);
    } finally {
      this.isInvitingAdmin$.next(false);
    }
  }

  async reInviteAdmin(name, phoneNumber, email, id, subdomain) {
    this.isReInvitingAdmin$.next(true);
    try {
      await this.adminRepository.reInviteAdmin(name, phoneNumber, email, id, subdomain);
      this.drawerRepository.toggleDrawer(false);
    } finally {
      this.isReInvitingAdmin$.next(false);
    }
  }

  async reInvitePatient(patient) {
    this.isReInvitingPatient$.next(true);
    try {
      await this.patientRepository.reinvitePatient(patient);
      this.drawerRepository.toggleDrawer(false);
    } finally {
      this.isReInvitingPatient$.next(false);
    }
  }

  get creatorToInvite$() {
    return this.creatorRepository.creatorToInvite$;
  }

  get adminToInvite$() {
    return this.adminRepository.adminToInvite$;
  }
}
